import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '../components/Home'
import NewAccount from '../components/NewAccount'
import Registration from '../components/Registration'
import Reaction from "../components/Reaction";
import EditPassword from '@/components/EditPassword'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  base: '/profiel',
  routes: [
    { path: '/', redirect: '/gegevens' },
    { path: '/inschrijven', component: NewAccount },
    { path: '/gegevens', component: Registration },
    { path: '/edit-password', component: EditPassword },
    { path: '/reaction', component: Reaction, meta: { hideWrapper: true } },
    { path: '/logout', redirect: '../logout' },
    // otherwise redirect to home
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/inschrijven', '/sso']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = window.localStorage.getItem('user')
  if (authRequired && (window.localStorage.getItem('user') === null || !loggedIn.length > 20)) {
    window.location.href = '/profiel/inschrijven'
  }
  next()
})
